import { render } from "./VeterinarianSelect.vue?vue&type=template&id=011d759a&scoped=true"
import script from "./VeterinarianSelect.vue?vue&type=script&lang=js"
export * from "./VeterinarianSelect.vue?vue&type=script&lang=js"

import "./VeterinarianSelect.vue?vue&type=style&index=0&id=011d759a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011d759a"]])

export default __exports__